import { Box } from "@mui/material";
import React, { ReactNode } from "react";

interface WidgetLayoutProps {
  children: ReactNode;
  footer?: ReactNode;
  header?: ReactNode;
}

export default function WidgetLayout(props: WidgetLayoutProps): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%"
      }}>
      {!!props.header && (
        <Box sx={{
          flex: "0 1 auto"
        }}>
          {props.header}
        </Box>
      )}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flex: "1 1 auto",
          overflow: "hidden",
          position: 'relative'
        }}>
        {props.children}
      </Box>
      {!!props.footer && (
        <Box sx={{
          flex: "0 1 auto"
        }}>
          {props.footer}
        </Box>
      )}
    </Box>
  );
}
